// 优惠券码复制功能
class CouponCopy {
  constructor() {
    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // 使用事件委托：在 document 上监听 click，这样动态插入到 DOM（例如弹窗）的按钮也能被处理
    if (this._delegated) return;
    this._delegated = true;

    document.addEventListener('click', (e) => {
      const button = e.target.closest && e.target.closest('.copy-btn');
      if (!button) return;
      e.preventDefault();
      this.copyCouponCode(button);
    });
  }

  copyCouponCode(button) {
    const couponCode = button.getAttribute('data-coupon-code');

    console.log('copy click')
    
    if (!couponCode) {
      console.error('code not find');
      return;
    }

    // 使用现代 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(couponCode)
        .then(() => {
          this.showCopySuccess(button);
        })
        .catch(err => {
          console.error('copy failed:', err);
          this.fallbackCopyText(couponCode, button);
        });
    } else {
      // 降级方案：使用传统的execCommand
      this.fallbackCopyText(couponCode, button);
    }
  }

  fallbackCopyText(text, button) {
    // 创建临时textarea元素
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showCopySuccess(button);
      } else {
        this.showCopyError(button);
      }
    } catch (err) {
      console.error('copy failed:', err);
      this.showCopyError(button);
    }
    
    // 清理临时元素
    document.body.removeChild(textArea);
  }

  showCopySuccess(button) {
    const originalText = button.textContent;
    
    // 添加成功状态样式
    button.classList.add('copied');
    button.textContent = 'Copied';
    
    // 3秒后恢复原始状态
    setTimeout(() => {
      button.classList.remove('copied');
      button.textContent = originalText;
    }, 3000);
    
    // 可选：显示成功提示
    this.showNotification('Coupon code copied to clipboard', 'success');
  }

  showCopyError(button) {
    const originalText = button.textContent;
    
    button.textContent = 'copy failed';
    button.style.backgroundColor = '#dc3545';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.style.backgroundColor = '';
    }, 3000);
    
    this.showNotification('copy failed', 'error');
  }

  showNotification(message, type = 'info') {
    // 创建简单的通知元素
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 4px;
      color: white;
      font-size: 14px;
      z-index: 10000;
      transition: all 0.3s ease;
      transform: translateX(100%);
      opacity: 0;
    `;
    
    if (type === 'success') {
      notification.style.backgroundColor = '#28a745';
    } else if (type === 'error') {
      notification.style.backgroundColor = '#dc3545';
    } else {
      notification.style.backgroundColor = '#007bff';
    }
    
    notification.textContent = message;
    document.body.appendChild(notification);
    
    // 显示动画
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
      notification.style.opacity = '1';
    }, 100);
    
    // 3秒后自动消失
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      notification.style.opacity = '0';
      
      setTimeout(() => {
        if (notification.parentNode) {
          document.body.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
}

// 初始化优惠券复制功能
document.addEventListener('DOMContentLoaded', () => {
  new CouponCopy();
});

// 导出供其他模块使用
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CouponCopy;
}